import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_UNPUBLISH';

const eventUnpublishActions = {
  UNPUBLISH_STARTED: `${prefix}_UNPUBLISH_STARTED`,
  UNPUBLISH_SUCCESS: `${prefix}_UNPUBLISH_SUCCESS`,
  UNPUBLISH_ERROR: `${prefix}_UNPUBLISH_ERROR`,

  UNPUBLISH_ALL_STARTED: `${prefix}_UNPUBLISH_ALL_STARTED`,
  UNPUBLISH_ALL_SUCCESS: `${prefix}_UNPUBLISH_ALL_SUCCESS`,
  UNPUBLISH_ALL_ERROR: `${prefix}_UNPUBLISH_ALL_ERROR`,
  
  doUnpublishAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventUnpublishActions.UNPUBLISH_ALL_STARTED,
      });
    
      const result = await EventService.unpublishAll(ids);

      dispatch({
        type: eventUnpublishActions.UNPUBLISH_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.unpublishAll.success', result.count),
      );
      
      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventUnpublishActions.UNPUBLISH_ALL_ERROR,
      });
    }
  },
};

export default eventUnpublishActions;
